import React from 'react'
import CameraIcon from '../../elements/icons/CameraIcon'
import { calculateAge } from '../../../utils'

const ApplicantTableSnippet = ({
  applicant, 
  imageHeightClass='h-[50px]', 
  imageWidthClass='w-[50px]', 
  showAdmissionNumber = false
}) => {
  return (
    <div className='flex items-center gap-x-2'>
        <div className={`bg-gray-50 rounded-[8px] flex items-center justify-center ${imageHeightClass} ${imageWidthClass}`} style={{
          backgroundImage: `url(" ${applicant?.passportPhotograph} ")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'none'
        }}>
            {(!applicant?.passportPhotograph || applicant?.passportPhotograph === '') &&
                <CameraIcon className={`w-6 h-6 text-gray-400`} />
            }
        </div>
        <div>
        <p className='text-sm'>{`${applicant?.firstName || ''}${applicant?.otherNames ? ` ${applicant?.otherNames} ` : ' '}${applicant?.lastName || ''}`} {showAdmissionNumber && `(${applicant.admissionNumber})`}</p>
        <p className='text-sm text-gray-500'>{calculateAge(applicant?.dob)} year old, {applicant?.gender?.toLowerCase()}</p>

        </div>
    </div>
  )
}

export default ApplicantTableSnippet